module.exports = __webpack_public_path__ + "static/media/ekonomi.f63b33dc.png";